'use strict';

define(
        'BetSlipAccountInfoCtrl',[],
        function () {

            function BetSlipAccountInfoCtrl($scope, $rootScope, $uibModal, $filter, PreferencesCookieFac, $interval, GTMFac, ContentFac, PreferencesFac) {
                var userPrefs = PreferencesCookieFac.getPreferences();

                var updateBalance = _.throttle(_updateBalanceThrottle, 4000, { trailing: false });

                if (!$rootScope.accountBalance) {
                    $rootScope.$broadcast('accountBalance_update');
                }

                $scope.$on('accountBalance_changed', function () {
                    $scope.data.accountBalance = $filter('currency')($rootScope.accountBalanceNumber, '$');
                    $scope.data.updatingBalance = false;
                });

                $scope.data = {
                    showBalance: userPrefs.balance_is_shown,
                    updatingBalance: false
                };

                try {
                    var balance_is_show = localStorage.getItem('balance_is_shown');
                    userPrefs.balance_is_shown = balance_is_show !== null ? balance_is_show : userPrefs.balance_is_shown;
                    $scope.data.showBalance = parseInt(userPrefs.balance_is_shown);
                } catch(e) { }

                $interval( function() {
                    try {
                        var balance_is_show = localStorage.getItem('balance_is_shown');
                        userPrefs.balance_is_shown = balance_is_show !== null ? balance_is_show : userPrefs.balance_is_shown;
                    } catch(e) { }
                }, 1000);

                function _updateBalanceThrottle() {
                    $scope.data.updatingBalance = true;
                    $rootScope.$emit('accountBalance_update');

                    var eventData = GTMFac.gaEventBuilder()
                        .withGaEventAction(GTMFac.Tvg4ScreenName() + ' Page Click')
                        .withGaEventCategory('Site Click')
                        .withGaEventLabel('Balance Refresh Button')
                        .withEventLabel('BetTicket-BalanceRefresh')
                        .build();

                    var genericEvent = GTMFac.genericEvent(eventData);

                    GTMFac.GTMEvent().send($rootScope, 'siteClick', genericEvent);
                }

                function _openQuickDeposit() {

                    var eventData = GTMFac.gaEventBuilder()
                        .withGaEventAction(GTMFac.Tvg4ScreenName() + ' Page Click')
                        .withGaEventCategory('Site Click')
                        .withGaEventLabel('Deposit Button')
                        .withEventLabel('BetTicket-Deposit')
                        .build();

                    var genericEvent = GTMFac.genericEvent(eventData);

                    GTMFac.GTMEvent().send($rootScope, 'siteClick', genericEvent);

                    ContentFac.fetchAllDataFromCMS(['Global', 'Deposits', 'Funds'])
                        .then(function () {
                            $scope.quickDepositModal = $uibModal.open({
                                windowClass: 'quick-deposit new-quick-deposit betslip-quick-deposit',
                                backdropClass: 'tvgmodal-backdrop',
                                windowTemplateUrl: 'js/modules/Utilities/templates/modal-window.html',
                                templateUrl: 'js/modules/UserProfile/templates/quick-deposit.html',
                                controller: 'QuickDepositCtrl'
                            });
                        });
                }

                $scope.events = {
                    openQuickDeposit: _openQuickDeposit,
                    updateBalance: updateBalance
                };

            }

            BetSlipAccountInfoCtrl.$inject = [
                '$scope',
                '$rootScope',
                '$uibModal',
                '$filter',
                'PreferencesCookieFac',
                '$interval',
                'GTMFac',
                'ContentFac',
                'PreferencesFac'
            ];

            return BetSlipAccountInfoCtrl;
        }
);

